import React, { useState, useMemo } from "react";
import KPIStrip from "../components/KPIStrip";
import WaterUsageFilters, {
  DEFAULT_FILTERS,
} from "../components/WaterUsageFilters";
import WeeklyTrendChart from "../components/WeeklyTrendChart";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "../context/ThemeContext";
import { getAccountMeterCategoryList } from "../services";
import { useEffect } from "react";
import { toast } from "react-toastify";
// =========================
// STATIC DATA
// =========================

// const CATEGORIES = [
//   { code: "IC", name: "Interconnect" },
//   { code: "NPS", name: "Non-Potable Supply" },
//   { code: "PD", name: "Potable Domestic" },
//   { code: "PF", name: "Potable Fire" },
//   { code: "PI", name: "Potable Irrigation" },
// ];

// const accounts = [
//   { id: 1, name: "Chick-Fil-A Summerwood" },
//   { id: 2, name: "City of Houston" },
//   { id: 3, name: "GHX Industrial" },
//   { id: 4, name: "Generation Park" },
//   { id: 5, name: "Kroger" },
//   { id: 6, name: "Lockwood" },
//   { id: 7, name: "Lone Star College" },
//   { id: 8, name: "Memorial Hermann Hospital" },
//   { id: 9, name: "San Jacinto Community College" },
//   { id: 10, name: "Service Wire Company" },
//   { id: 11, name: "Westlake Marketplace" },
//   { id: 12, name: "PHMSCM Holdings" },
// ];

// const meters = [
//   { id: "129122", name: "129122 — Westlake Marketplace" },
//   { id: "114476", name: "114476 — Generation Park" },
//   { id: "114477", name: "114477 — Lone Star College" },
//   { id: "101893", name: "101893 — Memorial Hermann Hospital" },
//   { id: "126171", name: "126171 — Kroger" },
//   { id: "96881H", name: "96881H — Lockwood" },
//   { id: "96882L", name: "96882L — Lockwood" },
//   { id: "95434", name: "95434 — San Jacinto Community College" },
//   { id: "129123", name: "129123 — Generation Park" },
//   { id: "17160335", name: "17160335 — City of Houston" },
//   { id: "47149L", name: "47149L — GHX Industrial" },
//   { id: "86287L", name: "86287L — Service Wire Company" },
// ];

const kpis = {
  supply: {
    value: 120000,
    deltaPct: 5.2,
  },
  demand: {
    value: 92000,
    deltaPct: 2.1,
  },
  loss: {
    value: 28000,
    deltaPct: -1.5,
  },
  avgDaily: {
    value: 4500,
    deltaPct: 1.2,
  },
  peak: {
    value: 9800,
    dateLabel: "May 10",
  },
};

const filteredKpis = {
  supply: {
    value: 9354300,
    deltaPct: 4.5,
  },
  demand: {
    value: 6165567,
    deltaPct: 4.1,
  },
  loss: {
    value: 3188733,
    deltaPct: 5.2,
  },
  avgDaily: {
    value: 311810,
    deltaPct: 4.2,
  },
  peak: {
    value: 520400,
    dateLabel: "Apr 30 (Thu)",
  },
};

const aggregate = [
  { x: "May 01", y: 12000 },
  { x: "May 02", y: 15000 },
  { x: "May 03", y: 11000 },
  { x: "May 04", y: 18000 },
  { x: "May 05", y: 17000 },
  { x: "May 06", y: 14000 },
  { x: "May 07", y: 19000 },
  { x: "May 08", y: 16000 },
  { x: "May 09", y: 13000 },
  { x: "May 10", y: 21000 },
  { x: "May 11", y: 17500 },
  { x: "May 12", y: 14500 },
  { x: "May 13", y: 22000 },
  { x: "May 14", y: 19500 },
  { x: "May 15", y: 25000 },

  // NEW 10 VALUES

  { x: "May 16", y: 23000 },
  { x: "May 17", y: 18500 },
  { x: "May 18", y: 26000 },
  { x: "May 19", y: 24000 },
  { x: "May 20", y: 27500 },
  { x: "May 21", y: 25500 },
  { x: "May 22", y: 29000 },
  { x: "May 23", y: 31000 },
  { x: "May 24", y: 28000 },
  { x: "May 25", y: 32500 },
];

const dailyAvg = [
  { x: "Weekday", y: 5600 },
  { x: "Weekend", y: 6800 },
  { x: "Monday", y: 4200 },
  { x: "Tuesday", y: 5100 },
  { x: "Wednesday", y: 4800 },
  { x: "Thursday", y: 5300 },
  { x: "Friday", y: 6200 },
  { x: "Saturday", y: 7100 },
  { x: "Sunday", y: 3900 },
];

const hourlyAvg = [
  { x: "12am", y: 10500 },
  { x: "1am", y: 9800 },
  { x: "2am", y: 9500 },
  { x: "3am", y: 9700 },
  { x: "4am", y: 10200 },
  { x: "5am", y: 12000 },
  { x: "6am", y: 14500 },
  { x: "7am", y: 16200 },
  { x: "8am", y: 15800 },
  { x: "9am", y: 14200 },
  { x: "10am", y: 13500 },
  { x: "11am", y: 13000 },
  { x: "12pm", y: 12800 },
  { x: "1pm", y: 12500 },
  { x: "2pm", y: 12300 },
  { x: "3pm", y: 13800 },
  { x: "4pm", y: 17500 },
  { x: "5pm", y: 21800 },
  { x: "6pm", y: 23200 },
  { x: "7pm", y: 21500 },
  { x: "8pm", y: 18200 },
  { x: "9pm", y: 15500 },
  { x: "10pm", y: 13200 },
  { x: "11pm", y: 11500 },
];

const categoryData = [
  { name: "Potable Domestic", value: 82.1 },
  { name: "Potable Irrigation", value: 16.2 },
  { name: "Non-Potable Supply", value: 1.0 },
  { name: "Potable Fire", value: 0.4 },
  { name: "Interconnect", value: 0.3 },
];
const topAccounts = [
  { name: "Westlake", value: 14832 },
  { name: "Gen Park", value: 12401 },
  { name: "Lone Star", value: 9876 },
  { name: "Mem Hermann", value: 8224 },
  { name: "Kroger", value: 7109 },
];
const weekly = [
  {
    name: "Apr 6–12",
    data: [2700, 2860, 2780, 2710, 2950, 2950, 2280],
  },
  {
    name: "Apr 13–19",
    data: [2750, 2890, 2810, 2740, 3000, 3010, 2310],
  },
  {
    name: "Apr 20–26",
    data: [2810, 2940, 2870, 3060, 3300, 3220, 2350],
  },
  {
    name: "Apr 27–May 3",
    data: [2880, 3010, 2920, 2840, 3120, 3812, 2410],
  },
];
const rankedMeters = [
  {
    meter_id: "129122",
    category: "Potable Domestic",
    account_name: "Westlake Marketplace",
    last_comm_time: "2026-05-04 14:32",
    flow: 14832,
  },
  {
    meter_id: "114476",
    category: "Potable Domestic",
    account_name: "Generation Park",
    last_comm_time: "2026-05-04 14:28",
    flow: 12401,
  },
  {
    meter_id: "114477",
    category: "Potable Domestic",
    account_name: "Lone Star College",
    last_comm_time: "2026-05-04 14:30",
    flow: 9876,
  },
  {
    meter_id: "101893",
    category: "Potable Irrigation",
    account_name: "Memorial Hermann Hospital",
    last_comm_time: "2026-05-04 14:31",
    flow: 8224,
  },
  {
    meter_id: "126171",
    category: "Potable Domestic",
    account_name: "Kroger",
    last_comm_time: "2026-05-04 14:25",
    flow: 7109,
  },
  {
    meter_id: "96881H",
    category: "Potable Fire",
    account_name: "Lockwood",
    last_comm_time: "2026-05-04 14:33",
    flow: 6543,
  },
  {
    meter_id: "96882L",
    category: "Potable Domestic",
    account_name: "Lockwood",
    last_comm_time: "2026-05-04 14:33",
    flow: 5981,
  },
  {
    meter_id: "95434",
    category: "Non-Potable Supply",
    account_name: "San Jacinto Community College",
    last_comm_time: "2026-05-04 14:18",
    flow: 4872,
  },
  {
    meter_id: "129123",
    category: "Non-Potable Supply",
    account_name: "Generation Park",
    last_comm_time: "2026-05-03 22:14",
    flow: 3920,
  },
  {
    meter_id: "17160335",
    category: "Interconnect",
    account_name: "City of Houston",
    last_comm_time: "2026-05-04 14:00",
    flow: 2110,
  },
  {
    meter_id: "47149L",
    category: "Potable Domestic",
    account_name: "GHX Industrial",
    last_comm_time: "2026-05-04 13:50",
    flow: 1845,
  },
  {
    meter_id: "86287L",
    category: "Potable Irrigation",
    account_name: "Service Wire Company",
    last_comm_time: "2026-05-04 13:30",
    flow: 1402,
  },
];
// =========================
// CHART BASE CONFIG
// =========================

const zoomToolbar = {
  show: true,
  tools: {
    download: false,
    selection: true,
    zoom: true,
    zoomin: true,
    zoomout: true,
    pan: true,
    reset: true,
  },
  autoSelected: "zoom",
};

const zoomConfig = {
  enabled: true,
  type: "x",
  autoScaleYaxis: true,
};

const darkBase = {
  chart: {
    foreColor: "#8ba1c7",
    toolbar: zoomToolbar,
    zoom: zoomConfig,
  },

  grid: {
    borderColor: "#233d5e",
    strokeDashArray: 3,
  },

  tooltip: {
    theme: "dark",
  },

  legend: {
    labels: {
      colors: "#e6f0ff",
    },
  },
};

// =========================
// COMPONENT
// =========================

const WaterCombined = () => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const [isLoading, setIsLoading] = useState(true);

  const [aggType, setAggType] = useState("bar");
  const [dailyType, setDailyType] = useState("bar");

  const [hourlyType, setHourlyType] = useState("line");
  const [acctType, setAcctType] = useState("bar");
  const [activeCategory, setActiveCategory] = useState(null);
  const { colors } = useTheme();

  const [dhTab, setDhTab] = useState("daily");

  const [hourlyDay, setHourlyDay] = useState("Weekdays");

  const [sort, setSort] = useState({
    key: "flow",
    dir: "desc",
  });
  const [options, setOptions] = useState({
    accounts: [],
    meters: [],
    categories: [],
  });
  const [loadingOptions, setLoadingOptions] = useState(false);
  const selectedAccountCount = filters.account?.length || 0;
  const selectedMeterCount = filters.meter?.length || 0;
  const selectedCategoryCount = filters.category?.length || 0;

  const isFilteredView =
    selectedAccountCount > 0 ||
    selectedMeterCount > 0 ||
    selectedCategoryCount > 0;

  const activeKpis = isFilteredView ? filteredKpis : kpis;

  const filteredText = [
    selectedAccountCount > 0 ? `${selectedAccountCount} account` : null,
    selectedMeterCount > 0 ? `${selectedMeterCount} meter` : null,
    selectedCategoryCount > 0 ? `${selectedCategoryCount} category` : null,
  ]
    .filter(Boolean)
    .join(" / ");

  const clearFilters = () => {
    setFilters({
      ...filters,
      account: [],
      meter: [],
      category: [],
    });
  };

  // =========================
  // KPI MODE
  // =========================

  // const kpiMode =
  //   filters.account?.length ||
  //   filters.meter?.length
  //     ? "filtered"
  //     : "district";

  // =========================
  // SORTING
  // =========================

  const sortedMeters = useMemo(() => {
    const dir = sort.dir === "asc" ? 1 : -1;

    return [...rankedMeters].sort((a, b) => {
      const av = a[sort.key];
      const bv = b[sort.key];

      if (typeof av === "number") {
        return (av - bv) * dir;
      }

      return String(av ?? "").localeCompare(String(bv ?? "")) * dir;
    });
  }, [sort]);

  const onSortClick = (key) => {
    if (key === "rank") return;

    setSort((s) =>
      s.key === key
        ? {
            key,
            dir: s.dir === "asc" ? "desc" : "asc",
          }
        : {
            key,
            dir: key === "flow" ? "desc" : "asc",
          },
    );
  };

  const sortClass = (key) =>
    "sortable" + (sort.key === key ? ` sort-${sort.dir}` : "");

  const sortArrow = (key) =>
    sort.key === key ? (sort.dir === "asc" ? "▲" : "▼") : "▲▼";

  // =========================
  // AGGREGATE CONFIG
  // =========================

  const aggregateConfig = useMemo(() => {
    return {
      ...darkBase,

      chart: {
        ...darkBase.chart,
        type: aggType,
        height: 320,
      },

      series: [
        {
          name: "Aggregate Flow",
          data: aggregate.map((p) => p.y),
        },
      ],

      xaxis: {
        categories: aggregate.map((p) => p.x),
      },

      yaxis: {
        labels: {
          formatter: (v) => Number(v).toLocaleString(),
        },
      },
      // REMOVE VALUES INSIDE BARS
      dataLabels: {
        enabled: false,
      },

      colors: ["#1998f0"],

      stroke:
        aggType === "line"
          ? {
              width: 3,
              curve: "smooth",
            }
          : {
              width: 0,
            },

      markers:
        aggType === "line"
          ? {
              size: 4,
            }
          : {
              size: 0,
            },

      plotOptions:
        aggType === "bar"
          ? {
              bar: {
                borderRadius: 2,
                columnWidth: "70%",
              },
            }
          : {},
    };
  }, [aggType]);

  // =========================
  // DAILY CONFIG
  // =========================

  const dailyConfig = useMemo(() => {
    return {
      ...darkBase,

      chart: {
        ...darkBase.chart,
        type: dailyType,
        height: 420,
      },

      series: [
        {
          name: "Daily Avg",
          data: dailyAvg.map((p) => p.y),
        },
      ],

      xaxis: {
        categories: dailyAvg.map((p) => p.x),

        labels: {
          style: {
            colors: "#8ba1c7",
            fontSize: "12px",
          },
        },
      },

      yaxis: {
        labels: {
          formatter: (v) => Number(v).toLocaleString(),

          style: {
            colors: "#8ba1c7",
          },
        },
      },

      colors: ["#1998f0"],

      dataLabels: {
        enabled: false,
      },

      stroke:
        dailyType === "line"
          ? {
              width: 4,
              curve: "smooth",
            }
          : {
              width: 0,
            },

      markers:
        dailyType === "line"
          ? {
              size: 5,
              strokeWidth: 2,
            }
          : {
              size: 0,
            },

      plotOptions:
        dailyType === "bar"
          ? {
              bar: {
                borderRadius: 4,
                columnWidth: "70%",
              },
            }
          : {},

      tooltip: {
        theme: "dark",
      },

      legend: {
        show: false,
      },
    };
  }, [dailyType]);

  // =========================
  // HOURLY CONFIG
  // =========================

  const hourlyConfig = useMemo(() => {
    return {
      ...darkBase,

      chart: {
        ...darkBase.chart,
        type: hourlyType,
        height: 420,
      },

      series: [
        {
          name: "Total Demand Hourly Avg",
          data: hourlyAvg.map((p) => p.y),
        },
      ],

      xaxis: {
        categories: hourlyAvg.map((p) => p.x),

        labels: {
          style: {
            colors: "#8ba1c7",
            fontSize: "11px",
          },
        },
      },

      yaxis: {
        labels: {
          formatter: (v) => Number(v).toLocaleString(),

          style: {
            colors: "#8ba1c7",
          },
        },
      },

      legend: {
        show: true,

        labels: {
          colors: "#8ba1c7",
        },
      },

      dataLabels: {
        enabled: false,
      },

      colors: ["#1998f0"],

      stroke:
        hourlyType === "line"
          ? {
              width: 3,
              curve: "monotoneCubic",
            }
          : {
              width: 0,
            },

      markers:
        hourlyType === "line"
          ? {
              size: 5,
            }
          : {
              size: 0,
            },

      plotOptions:
        hourlyType === "bar"
          ? {
              bar: {
                borderRadius: 4,
                columnWidth: "70%",
              },
            }
          : {},
    };
  }, [hourlyType]);

  // =========================
  // CATEGORY CONFIG
  // =========================

  const categoryConfig = {
    ...darkBase,

    chart: {
      ...darkBase.chart,
      type: "donut",
      height: 320,
      toolbar: {
        show: false,
      },

      events: {
        dataPointMouseEnter: (event, chartContext, config) => {
          const index = config.dataPointIndex;

          if (index >= 0) {
            setActiveCategory({
              name: categoryData[index].name,
              value: categoryData[index].value,
            });
          }
        },

        dataPointMouseLeave: () => {
          setActiveCategory(null);
        },
      },
    },

    series: categoryData.map((c) => c.value),

    labels: categoryData.map((c) => c.name),

    colors: ["#2ea8ff", "#30c5d8", "#ff7b1a", "#c05be3", "#7ed37e"],

    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",

      labels: {
        colors: "#ffffff",
      },

      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },

      itemMargin: {
        horizontal: 8,
        vertical: 6,
      },
    },

    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,

      style: {
        fontSize: "12px",
        fontWeight: 700,
        colors: ["#000000"],
      },

      dropShadow: {
        enabled: false,
      },
    },

    stroke: {
      width: 2,
      colors: ["#132742"],
    },

    plotOptions: {
      pie: {
        expandOnClick: false,

        donut: {
          size: "62%",

          labels: {
            show: true,

            name: {
              show: true,
              color: "#8ba1c7",
              fontSize: "16px",
              fontWeight: 400,
              offsetY: -8,

              formatter: () =>
                activeCategory ? activeCategory.name : "Total gal",
            },

            value: {
              show: true,
              color: "#8ba1c7",
              fontSize: "24px",
              fontWeight: 500,
              offsetY: 8,

              formatter: () =>
                activeCategory
                  ? `${activeCategory.value.toFixed(1)}%`
                  : "6,165,569",
            },

            total: {
              show: true,
              showAlways: true,
              label: activeCategory ? activeCategory.name : "Total gal",
              color: "#8ba1c7",
              fontSize: "16px",
              fontWeight: 400,

              formatter: () =>
                activeCategory
                  ? `${activeCategory.value.toFixed(1)}%`
                  : "6,165,569",
            },
          },
        },
      },
    },

    tooltip: {
      theme: "dark",
    },
  };

  // =========================
  // ACCOUNT CONFIG
  // =========================

  const accountConfig = useMemo(() => {
    return {
      ...darkBase,

      chart: {
        ...darkBase.chart,
        type: acctType,
        height: 300,
      },

      series: [
        {
          name: "Total Flow",
          data: topAccounts.map((a) => a.value),
        },
      ],

      xaxis: {
        categories: topAccounts.map((a) => a.name),

        labels: {
          style: {
            colors: "#8ba1c7",
          },
        },
      },

      yaxis: {
        labels: {
          style: {
            colors: "#8ba1c7",
          },
        },
      },

      colors: ["#2ea8ff"],

      dataLabels: {
        enabled: true,

        formatter: (value) => Number(value).toLocaleString(),

        offsetY: acctType === "line" ? -10 : 0,

        background: {
          enabled: false,
        },

        style: {
          colors: ["#ffffff"],
          fontSize: "12px",
          fontWeight: 700,
        },
      },

      plotOptions:
        acctType === "bar"
          ? {
              bar: {
                horizontal: true,
                borderRadius: 4,
                barHeight: "55%",
              },
            }
          : {},

      stroke:
        acctType === "line"
          ? {
              width: 3,
              curve: "smooth",
            }
          : {
              width: 0,
            },

      markers:
        acctType === "line"
          ? {
              size: 5,
              strokeWidth: 2,
              strokeColors: "#ffffff",
              hover: {
                size: 7,
              },
            }
          : {
              size: 0,
            },
    };
  }, [acctType]);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setLoadingOptions(true);
        const response = await getAccountMeterCategoryList();

        // Console log to verify the structure
        console.log("Fetched dropdown options:", response);

        // Based on your JSON, the data is inside response.data
        const apiData = response?.data;

        if (apiData) {
          setOptions({
            // 1. Map accounts: data.accounts is an array of objects { account_name: "..." }
            accounts: (apiData.accounts || []).map((acc) => ({
              id: acc.account_name, // Use account_name as ID since no explicit ID is provided
              name: acc.account_name,
            })),

            // 2. Map meters: data.meters is an array of objects { meter_id: "..." }
            meters: (apiData.meters || []).map((m) => ({
              id: m.meter_id,
              name: m.meter_id,
            })),

            // 3. Map categories: data.codes is an array of objects { code: "...", code_name: "..." }
            categories: (apiData.codes || []).map((c) => ({
              code: c.code,
              name: c.code_name, // Use the friendly name here
            })),
          });
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
        toast.error("Failed to load filter options");
      } finally {
        setLoadingOptions(false);
      }
    };

    fetchOptions();
  }, []);

  // =========================
  // RENDER
  // =========================

  return (
    <div className="water-usage-page p-0">
      <h1
        className="text-4xl font-bold bg-clip-text text-transparent"
        style={{
          backgroundImage: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: "normal",
        }}
      >
        Water Usage
      </h1>

      <p className="text-slate-400 mt-2">
        District-wide consumption across meters, accounts, and categories
      </p>

      {/* <WaterUsageFilters
        accounts={accounts}
        meters={meters}
        categories={CATEGORIES}
        value={filters}
        onChange={setFilters}
        onDownload={() => {}}
      /> */}
      <WaterUsageFilters
        accounts={options.accounts}
        meters={options.meters}
        categories={options.categories}
        value={filters}
        onChange={setFilters}
        onDownload={() => {}}
      />
      {isFilteredView && (
        <div className="flex items-center gap-3 mt-4 text-[12px]">
          <span className="text-[#8ba1c7]">
            ● Filtered view: {filteredText}
          </span>

          <button
            onClick={clearFilters}
            className="text-[#2ea8ff] hover:text-white transition-all text-[12px]"
          >
            × Clear
          </button>
        </div>
      )}

      <KPIStrip mode="district" data={activeKpis} />

      {/* Aggregate */}

      <SectionHeader
        title="District Aggregate Flow"
        badge="all meters · daily"
      />

      <div className="bg-[#081b2d] border border-cyan-900/40 rounded-2xl p-5 mb-4 relative">
        {/* INSIDE GRAPH CARD - TOP RIGHT */}
        <div className="absolute top-4 right-5 z-10">
          <ChartTypeToggle value={aggType} onChange={setAggType} />
        </div>

        <ReactApexChart
          options={aggregateConfig}
          series={aggregateConfig.series}
          type={aggregateConfig.chart.type}
          height={aggregateConfig.chart.height}
        />
      </div>

      {/* Daily / Hourly */}

      {/* <SectionHeader
        title="Daily / Hourly Average"
        badge="averages"
      >
        <ChartTypeToggle
          value={dhType}
          onChange={setDhType}
        />
      </SectionHeader> */}

      <div className="bg-[#081b2d] border border-cyan-900/40 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-5">
          {/* LEFT TABS */}
          <div className="flex items-center gap-2 bg-[#132742] border border-[#23446f] rounded-lg p-1">
            <button
              onClick={() => setDhTab("daily")}
              className={`px-4 py-2 rounded-md text-sm transition-all ${
                dhTab === "daily" ? "bg-[#2ea8ff] text-white" : "text-[#8ba1c7]"
              }`}
            >
              📅 Daily Average
            </button>

            <button
              onClick={() => setDhTab("hourly")}
              className={`px-4 py-2 rounded-md text-sm transition-all ${
                dhTab === "hourly"
                  ? "bg-[#2ea8ff] text-white"
                  : "text-[#8ba1c7]"
              }`}
            >
              ⏱ Hourly Average
            </button>
          </div>

          {/* RIGHT TOGGLE */}
          {dhTab === "daily" ? (
            <ChartTypeToggle value={dailyType} onChange={setDailyType} />
          ) : (
            <ChartTypeToggle value={hourlyType} onChange={setHourlyType} />
          )}
        </div>

        {dhTab === "daily" ? (
          <ReactApexChart
            options={dailyConfig}
            series={dailyConfig.series}
            type={dailyConfig.chart.type}
            height={dailyConfig.chart.height}
          />
        ) : (
          <div className="grid grid-cols-12 gap-6">
            {/* LEFT FILTER PANEL */}
            <div className="col-span-12 lg:col-span-2">
              <div className="bg-[#132742] border border-[#23446f] rounded-xl p-4 min-h-[420px]">
                <div className="space-y-4">
                  {[
                    "Weekdays",
                    "Weekends",
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ].map((day) => (
                    <label
                      key={day}
                      className="flex items-center gap-3 text-white text-sm cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="hourlyDay"
                        checked={hourlyDay === day}
                        onChange={() => setHourlyDay(day)}
                        className="accent-cyan-500"
                      />

                      <span>{day}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT CHART */}
            <div className="col-span-12 lg:col-span-10">
              <ReactApexChart
                options={hourlyConfig}
                series={hourlyConfig.series}
                type={hourlyConfig.chart.type}
                height={hourlyConfig.chart.height}
              />
            </div>
          </div>
        )}
      </div>

      {/* Breakdown */}

      <SectionHeader title="Breakdown" badge="by category & account" />

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-stretch">
        {/* LEFT DONUT CARD */}
        <div className="bg-[#132742] border border-[#23446f] rounded-xl p-5 h-[520px]">
          <div className="text-[#8ba1c7] text-sm mb-2">
            By category — share of total district flow
          </div>

          <ReactApexChart
            options={categoryConfig}
            series={categoryConfig.series}
            type="donut"
            height={320}
          />
        </div>

        {/* RIGHT TOP ACCOUNTS CARD */}
        <div className="bg-[#132742] border border-[#23446f] rounded-xl p-5 h-[420px]">
          <div className="flex items-start justify-between mb-3">
            <div className="text-[#8ba1c7] text-sm">
              Top accounts — total flow in range
            </div>

            <ChartTypeToggle value={acctType} onChange={setAcctType} />
          </div>

          <ReactApexChart
            options={accountConfig}
            series={accountConfig.series}
            type={accountConfig.chart.type}
            height={290}
          />
        </div>
      </div>
      {/* Weekly */}

      <SectionHeader
        title="Weekly Trend"
        badge="Mon → Sun, one line per ISO week"
      />

      <div className="bg-[#132742] border border-[#23446f] rounded-md p-5">
        <p className="text-[#8ba1c7] text-sm mb-4">
          Day-of-week pattern across the selected range. Click a week in the
          legend to isolate it.
        </p>

        <WeeklyTrendChart weeks={weekly} height={360} />
      </div>

      {/* Table */}

      <SectionHeader title="Meters by Flow" badge="ranked" />

      <div className="bg-[#132742] border border-[#23446f] rounded-md p-4 overflow-auto mb-4">
        <p className="text-[#8ba1c7] text-sm mb-4">
          Click any column header to sort. Click a meter or account to filter.
        </p>

        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-[#18304d] text-[#8ba1c7] uppercase text-xs tracking-wide">
              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSortClick("rank")}
              >
                # <span className="text-[#526983]">▲▼</span>
              </th>

              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSortClick("meter_id")}
              >
                Meter <span className="text-[#526983]">▲▼</span>
              </th>

              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSortClick("category")}
              >
                Category <span className="text-[#526983]">▲▼</span>
              </th>

              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSortClick("account_name")}
              >
                Account <span className="text-[#526983]">▲▼</span>
              </th>

              <th
                className="px-4 py-3 text-left cursor-pointer"
                onClick={() => onSortClick("last_comm_time")}
              >
                Last Comm <span className="text-[#526983]">▲▼</span>
              </th>

              <th
                className="px-4 py-3 text-right cursor-pointer text-[#1998f0]"
                onClick={() => onSortClick("flow")}
              >
                Flow (gal) <span>▼</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedMeters.map((m, i) => (
              <tr
                key={m.meter_id}
                className="border-b border-[#2a4262] hover:bg-[#18304d]/60 transition-colors"
              >
                <td className="px-4 py-3 text-white">{i + 1}</td>

                <td className="px-4 py-3 text-[#1998f0] cursor-pointer">
                  {m.meter_id}
                </td>

                <td className="px-4 py-3 text-white">{m.category}</td>

                <td className="px-4 py-3 text-[#1998f0] cursor-pointer">
                  {m.account_name}
                </td>

                <td className="px-4 py-3 text-white">{m.last_comm_time}</td>

                <td className="px-4 py-3 text-right text-[#1998f0] font-semibold">
                  {Number(m.flow).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// =========================
// HELPERS
// =========================

function SectionHeader({ title, badge, children }) {
  return (
    <div className="flex items-center justify-between mb-3 mt-8">
      {/* LEFT */}
      <div className="flex items-center gap-3">
        <h2 className="text-[16px] font-semibold text-white">{title}</h2>

        {badge && (
          <span className="px-3 py-1 rounded-full text-[11px] bg-[#0b2b44] text-[#2ea8ff] border border-[#1f4f75]">
            {badge}
          </span>
        )}
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3">
        <button className="text-[#8ba1c7] hover:text-white text-[14px]">
          ↓ Download
        </button>

        {children}
      </div>
    </div>
  );
}
function ChartTypeToggle({ value, onChange }) {
  return (
    <div className="flex items-center bg-[#0d223a] border border-[#23446f] rounded-lg overflow-hidden h-[34px]">
      <button
        onClick={() => onChange("bar")}
        className={`px-4 h-full text-sm font-medium transition-all ${
          value === "bar" ? "bg-[#2ea8ff] text-white" : "text-[#8ba1c7]"
        }`}
      >
        ▮▮
      </button>

      <button
        onClick={() => onChange("line")}
        className={`px-4 h-full text-sm font-medium transition-all ${
          value === "line" ? "bg-[#2ea8ff] text-white" : "text-[#8ba1c7]"
        }`}
      >
        ∿
      </button>
    </div>
  );
}

export default WaterCombined;
